import { render, staticRenderFns } from "./stage-stamp.vue?vue&type=template&id=4397f046&scoped=true&lang=pug"
import script from "./stage-stamp.vue?vue&type=script&lang=js"
export * from "./stage-stamp.vue?vue&type=script&lang=js"
import style0 from "./stage-stamp.vue?vue&type=style&index=0&id=4397f046&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4397f046",
  null
  
)

export default component.exports